import { Box } from '@mui/material';
import { useCreate, useGo, useResourceParams } from '@refinedev/core';
import { Create } from '@refinedev/mui';
import { useForm } from '@refinedev/react-hook-form';
import { FormProvider } from 'react-hook-form';

import { ATTACKIQ_ID } from '@attackiq/constants/platform';

import {
  CreditsInput,
  DescriptionInput,
  FeaturedCheckbox,
  NameInput,
  PackageArchSelector,
  PackageOSSelector,
  PackageTypeInput,
  ProjectTemplateInput,
  PurposeInput
} from './components/input_components';

const FlexPackagesCreate = () => {
  const { saveButtonProps, ...formMethods } = useForm({
    refineCoreProps: {
      resource: 'flex_packages',
      action: 'create',
      redirect: false
    }
  });
  const { mutateAsync: createAsync } = useCreate();

  const { resource } = useResourceParams();
  const go = useGo();

  const { handleSubmit } = formMethods;

  const onSubmit = handleSubmit(
    async ({ name, description, package_type, project_template, credits, featured, purpose, os, arch }) => {
      await createAsync({
        resource: 'flex_packages',
        values: {
          name: name,
          description: description ? description : '',
          package_type: package_type.id,
          project_template: project_template.id,
          version: '0.0.0',
          credits: credits,
          featured: featured,
          purpose: purpose,
          company_id: ATTACKIQ_ID,
          os: os,
          arch: arch
        }
      });
      go({
        to: {
          resource: resource?.name ?? 'flex_packages',
          action: 'list'
        }
      });
    }
  );

  return (
    <FormProvider {...formMethods}>
      <form name="create-flex-packages-form" onSubmit={onSubmit}>
        <Create saveButtonProps={{ type: 'submit' }}>
          <Box display="flex" flexDirection="column" gap={2}>
            <NameInput />
            <DescriptionInput />
            <PackageTypeInput />
            <ProjectTemplateInput />
            <CreditsInput />
            <FeaturedCheckbox />
            <PurposeInput />
            <PackageOSSelector />
            <PackageArchSelector />
          </Box>
        </Create>
      </form>
    </FormProvider>
  );
};

export default FlexPackagesCreate;
